module.exports = __webpack_public_path__ + "assets/support-woman.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/support-woman.jpg
// module id = 1667
// module chunks = 7